module.exports = __webpack_public_path__ + "img/set-and-go.8031c8a4.svg";